// France
export const locale = {
  lang: 'fr',
  data: {
    mare: 'jument',
    gelding: 'hongre',
    stallion: 'male',
    maintenance: {
      title: 'Maintenance',
      message:
        'Notre site web est actuellement en maintenance. Veuillez revenir plus tard. Merci pour votre compréhension.',
    },
    STREAMING: {
      DIAGNOSTICS: 'Diagnostic vidéo',
      COPY_DIAGNOSTICS: 'Copier le diagnostic',
      DIAGNOSTICS_HELP: 'Si la copie automatique échoue, sélectionnez puis copiez le texte ci-dessous. Rien n’est envoyé automatiquement.',
      RECONNECTING: 'Reconnexion…',
      PAUSE: 'Pause',
      RESUME: 'Reprendre',
      TAP_TO_PLAY: 'Appuyez pour regarder',

      RACE_FINISHED: 'Terminée',
      COVERAGE: 'Diffusion',
      SHOW: 'Afficher',
      HIDE: 'Masquer',
      OTHER_STREAMS: 'Autres directs',
      CHOOSE_TRACK: 'Choisir un direct',
      CHANNEL_NUMBER: 'Chaîne {{number}}',
      IN_MINUTES: 'dans {{minutes}} min',
      AT_TIME: 'à {{time}}',
      AT_POST: 'Au départ',
      LIVE: 'En direct',
      FINISHED: 'Terminée',
      SHORT_UNAVAILABLE: 'Indisponible',
      SCHEDULE_PENDING: 'Horaire à venir',

      BROWSER_UNSUPPORTED: 'Ce navigateur ne peut pas lire ce direct. Essayez un autre navigateur ou choisissez PMU TV.',
      QUINTE: 'Quinté+',
      GUIDE: 'En direct des hippodromes',
      VIDEO: 'Vidéo des courses en direct',
      CHANNEL: 'Choisir une chaîne',
      PMU: 'PMU TV',
      BACK_TO_PMU: 'Regarder PMU TV',
      CONNECTING: 'Connexion au direct…',
      LOADING: 'Chargement des réunions du jour…',
      UPDATED: 'Mis à jour à',
      RETRY: 'Réessayer',
      STALE: 'Mise à jour du programme retardée.',
      GUIDE_ERROR: 'Liste des réunions indisponible. PMU TV reste disponible.',
      DISABLED: 'Les directs par réunion sont momentanément indisponibles.',
      EMPTY: 'Aucun direct par réunion n’est encore programmé.',
      PLAYBACK_ERROR: 'Ce direct est momentanément indisponible. Réessayez ou choisissez une autre chaîne.',
      ACCESS_ERROR: 'Votre session vidéo n’est plus disponible. Reconnectez-vous ou choisissez PMU TV.',
      REUNION_SHORT: 'R',
      RACE_SHORT: 'C',
      PHASE_live: 'Direct · estimé',
      PHASE_onair: 'À l’antenne',
      PHASE_upcoming: 'À venir',
      PHASE_ended: 'Terminée',
      PHASE_unknown: 'Programme en attente',
      STARTS_IN: 'Départ dans',
      ESTIMATED: 'Horaire estimé',
      SHARED_SIGNAL: 'Signal partagé avec {{meeting}}',
      UNAVAILABLE: 'Direct indisponible',
      SELECTION_CHANGED: 'Cette réunion ne figure plus au programme.',
      SCHEDULE_NOTE: 'Les horaires et indicateurs de course sont des estimations pour la vidéo. Consultez la page de la course pour le statut des paris.',
    },
    GENERAL: {
      RACES: 'Courses',
      DELETE: 'Placer le pari',
      ONE_MOMENT: 'Chargement...',
      CLOSE: 'Fermer',
      PRINT: 'Imprimer',
      CONFIRM: 'Confirmer',
      CANCEL: 'Annuler',
      CANCEL_BUTTON: 'Annuler',
      RESULT: 'Rapport',
      TEMPORARY_RESULT: 'Résultat temporaire',
      BACK_BUTTON: 'Back',
      PRIVACY: 'Privacy',
      LEGAL: 'Legal',
      CONTACT: 'Contact',
      SELECT: 'choisissez votre langue',
      LANGUAGE: 'Langue',
      PLEASE_KEEP_THESE_INFORMATION_SAFE:
        'Veuillez garder ces informations en sécurité',
    },
    BETTING_SLIP: {
      YOUR_BETTING_SLIP: 'Votre bulletin de pari',
    },
    MENU: {
      HOME: 'ACCUEIL',
      ALL_RACES: 'COURSES MONDIALES',
      ALL_RACES_SHORT: 'MONDIALE',
      PMU_RACES: 'COURSES PMU',
      PMU_RACES_SHORT: 'PMU',
      NEXT_RACES: 'COURSES SUIVANTES',
      NEXT_RACES_SHORT: 'DÉPART',
      STREAMING: 'Live Streaming',
      BET_TYPES: 'Types de paris',
      DEPOSIT_WITHDRAWAL: 'Dépôts & retraits',
      TERMS: 'Conditions générales',
      CONTACT: 'Contact',
      VIRTUALS: 'VIRTUEL',
    },
    VIRTUALS: {
      TITLE: 'Golden Race',
      OPENING: 'Ouverture de Golden Race…',
      LEAVING: 'Fermeture de Golden Race…',
      RETRY: 'Réessayer',
      LOADING: 'Chargement du jeu…',
      RECONNECTING: 'Reconnexion…',
      UNAVAILABLE: 'Golden Race est momentanément indisponible. Réessayez dans quelques instants.',
      ERROR: 'Impossible de lancer le jeu. Réessayez dans quelques instants.',
      CONFIG_ERROR: "Golden Race n'est pas disponible pour le moment. Notre équipe est prévenue.",
      CURRENCY_UNSUPPORTED:
        "Golden Race n'est pas encore disponible pour la devise de votre compte.",
      NOT_ENABLED: 'Golden Race n\'est pas encore disponible pour votre compte.',
      DEPOSIT_ERROR:
        "La fenêtre de dépôt n'a pas pu s'ouvrir. Réessayez ou utilisez le bouton Dépôt en haut de la page.",
    },
    SUPPORT: {
      TITLE: 'Support',
      LIVE_CHAT: 'Chat en direct',
      MESSAGE: 'Message',
      HELP: 'Aide',
      UNAVAILABLE: 'Le chat support est momentanément indisponible. Veuillez réessayer plus tard.',
    },
    HOME: {
      CALENDAR: 'Calendrier',
      TODAY: "Aujourd'hui",
      YESTERDAY: 'Hier',
      TOMORROW: 'Demain',
      COUNTRIES: 'Pays',
      NEXT_BETTING: 'Prochaines chances',
      NEXT_PMU_BETTING: 'Prochaines courses PMU',
      MORE: 'Voir plus',
      JACKPOT: 'Jackpot',
      ACCUMULATOR_TITLE: 'Bet Box/pari accumulateur',
      ACCUMULATOR_DESC:
        'Aucun cheval sélectionné pour le pari accumulateur. Cliquez sur la cote de la course.',
      STARTER_SEARCH: 'Recherche de départ',
      SEARCH: 'Rechercher',
      HEAD_TO_HEAD: 'Tête à Tête',
      HEAD_TO_HEAD_DESC:
        "Il n'y a pas d'appariement Tête à Tête disponible aujourd'hui.",
      HIGHLIGHTS: 'Faits marquants',
      STARTER_INDEX: 'Index de démarrage',
      LOGIN: 'CONNEXION | INSCRIPTION',
      LOGIN_SHORT: 'CONNEXION',
      LOGIN_BUTTON_MODAL: 'CONNEXION',
      LOGOUT: 'Déconnexion',
      STARTING: 'Départ de la course...',
      STARTING_SHORT: 'Départ..',
      IN: 'dans',
      MAINTANANCE:
        'NOTRE PLATEFORME SERA INDISPONIBLE LE MARDI 08/11/2022, ENTRE 23:00 - 02:00 CEST EN RAISON DE MAINTENANCE',
      NOT_SHOW: 'Ne plus afficher.',
    },
    RACES: {
      WAITING_FOR_APPROVE: 'En attente de validation',
      MANUALREVIEW: 'Revue manuelle',
      CANCELREASON: 'Motif dannulation',
      COMBINAISON: 'Combinaison',
      PRIZE_MONEY: 'Allocation',
      DISTANCE: 'Distance',
      SOIL: 'Sol',
      STARTERS: 'Partants',
      RESULT: 'Rapport',
      STARTED: "C'est parti",
      CANCEL_BUTTON: 'Annuler',
      BETTING_SLIP: 'Réf',
      START_TYPE: 'Type de départ',
      NON_STARTERS: 'Non-partants',
      TYPE_OF_BET: 'Type de Pari',
      STAKES: 'Mise',
      KEYPAD_DONE: 'Terminé',
      STAKE: 'Mise',
      TIME_RACE: 'Heure/Course',
      MARKINGS: 'Sélectionné(s)',
      EV: 'Cote',
      WIN: 'Gagnant',
      BET: 'Pari',
      NEW: 'Nouveau',
      NUMBER_OF_BETS: 'Nombre de paris',
      PLACE_BET: 'Placer le pari',
      PLACE_BET_PRINT: 'Date',
      PAY_FOR_BET: 'Confirmer',
      CONFIRM_TEXT: 'Le coût total du pari est de',
      POTENTIAL_WINNINGS: 'Gains potentiels',
      TOTAL_STAKES: 'Total des mises',
      TOTAL_PRICE: 'Prix total',
      STAKES_IN: 'Mise en',
      RACING_CLUB: 'Courtier de pari',
      MORE_BOOKIE_BETS: 'Courtier de pari',
      BOOKMAKER: 'Pari bookie',
      FIXED_ODDS_BET: 'Pari à cote fixe',
      SHOW_BETTING_SLIP: 'Afficher le ticket de pari',
      HIDE_BETTING_SLIP: 'Cacher le ticket de pari',
      MY_BETS: 'Mes paris',
      WINNINGS: 'Gains',
      TOP_WINNINGS: 'Gagnants du jour',
      NUMBER: 'Numéro',
      OPEN: 'Ouvert',
      LOST: 'Perdu',
      WON: 'Gagné',
      CANCELED: 'Annulé',
      STATUS: 'Statut',
      HORSE: 'Cheval',
      FORM: 'Forme',
      WEIGHT: 'Poids',
      TRAINER: 'Entraîneur',
      SP: 'Cote',
      FIXED_ODDS: 'Cote fixe',
      ORIGIN: 'Origines',
      LINEAGE: 'Lignée',
      OWNER: 'Propriètaire',
      AGE: 'Age',
      JOCKEY: 'Jockey',
      PLACE: 'Place',
      TOTAL: 'Total',
      TOTAL_WON: 'Gain Totale',
      TOTAL_LOST: 'Perte Totale',
      TOTAL_BETS: 'Total des paris',
      TOTAL_CANCELED: 'Total annulé',
      TOTAL_REFUND: 'Total remboursé',
      TOTAL_CASHBACK: 'Total Cashback',
      DATE: 'Date',
      RACE: 'Course',
      RACE_C: 'C',
      RACE_LOCATION: 'Réunion',
      BET_TYPES: 'Types de pari',
      CONFIRM_YOUR_BET: 'Confirmer votre Pari',
      GO_TO_RACE: 'Allez à la course',
      DOG: 'Chien',
      DRIVER: 'Conducteur',
      RECORD_TIME: 'Temps record',
      NO_OF_STARTS: 'Nb de démarrages',
      NO_OF_WINS: 'Nbre de victoires',
      NO_OF_PLACES: 'Nbre de places',
      QUINELLA: 'Jumelé',
      SWINGER: 'Jumelé placé',
      QUINELLA_SWINGER: 'Jumelé/Jumelé placé',
      EXACTA: 'Couplé',
      QUINTE: 'Quinte+ Champ',
      'QUINTÉ+': 'Quinte+',
      'QUINTÉ+_7': 'Quinte Ordre',
      'QUINTÉ+_6': 'Quinte Désordre',
      'QUINTÉ+_4': 'Quinte Ordre',
      'QUINTÉ+_3': 'Quinte Ordre',
      'QUINTÉ+_2': 'Quinte Désordre',
      'QUINTÉ+_1': 'Quinte Bonus 4',
      'QUINTÉ+_0': 'Quinte Bonus 3',
      QUINTE_STANDARD: 'Quinte Standard',
      TRIFECTA: 'Trifecta',
      TIERCE: 'Tiercé Champ',
      'TIERCÉ_-1': 'Tiercé Champ',
      TIERCÉ: 'Tiercé',
      TIERCÉ_1: 'Tiercé Ordre',
      TIERCÉ_0: 'Tiercé Désordre',
      TIERCE_STANDARD: 'Tiercé Standard',
      'TIERCÉ STANDARD': 'Tiercé Standard',
      'TIERCÉ CHAMP_0': 'Tiercé Désordre',
      'TIERCÉ CHAMP_1': 'Tiercé Ordre',
      QUARTE: 'Quarté Champ',
      'QUARTÉ+': 'Quarté+',
      'QUARTÉ+_-1': 'Quarté Champ',
      'QUARTÉ+_2': 'Quarté Ordre',
      'QUARTÉ+_1': 'Quarté Désordre',
      'QUARTÉ+_0': 'Quarté Bonus',
      'QUARTÉ+ CHAMP_0': 'Quarté Bonus',
      'QUARTÉ+ CHAMP_1': 'Quarté Désordre',
      'QUARTÉ+ CHAMP_2': 'Quarté Ordre',
      'QUARTÉ+ STANDARD': 'Quarté Standard',
      QUARTE_STANDARD: 'Quarté Standard',
      DEAD_HEAT: 'ex æquo',
      WIN_PLACE: 'Gagnant/Place',
      AMOUNT: 'Montant',
      BALANCE: 'Solde',
      PROFIT_FROM_BETTING: 'Gains',
      TRANSACTION_DETAILS: 'Détails de la transaction',
      TRANSACTION_TYPE: 'Type de transaction',
      PAY_ADDRESS: 'Adresse de paiement',
      APPLIED_AMOUNT: 'Montant appliqué',
      OUTCOME_AMOUNT: 'Montant du résultat',
      WAITING: 'En attente',
      CREATING: 'En cours de création',
      PROCESSING: 'En cours de traitement',
      CONFIRMING: 'En cours de confirmation',
      CONFIRMED: 'Confirmé',
      SENDING: "En cours d'envoi",
      PARTIALLY_PAID: 'Partiellement payé',
      FINISHED: 'Terminé',
      FAILED: 'Échoué',
      REJECTED: 'Rejeté',
      REJECTED_NOT_CHECKED: 'Rejeté non vérifié',
      REFUNDED: 'Remboursé',
      EXPIRED: 'Expiré',
      CANCELED_BY_USER: "Annulé par l'utilisateur",
      DEPOSIT: 'Dépôt',
      WITHDRAWAL: 'Retrait',
      SELECT_COUNTRY: 'Sélectionner le pays',
      SELECT_CURRENCY: 'Sélectionner la devise',
      REFUND: 'Remboursé',
      CANCEL: 'Annulé',
      CASHBACK: 'Remise en Argent',
      FINISH: 'Terminé',
      RACE_NR: 'Course',
      RACE_NR_C: 'C',
      ODDS: 'Cotes',
      R: 'C',
      ALL: 'Tous',
      CANCELLATIONS: 'Annulations',
      BETS: 'Paris',
      NOT_FOUND_RACE: 'Course Non Trouvée',
      CURRENT_FIXED_ODDS: 'Cotes fixes actuelles',
      J: 'ans.',
      MARE: 'jument',
      STALLION: 'male',
      GELDING: 'hongre',
      T: 'E',
      NO_BET: "Vous n'avez pas encore parié sur cette course",
      CANCEL_COUPON: 'Annuler le coupon',
      COUPON_CANCELLED_MESSAGE: '{{betSlipId}} a été annulé avec succès',
      COUPON_CANCELLED_ERROR_MESSAGE:
        "La limite d'annulation du coupon a été dépassée",
      SHOW_CHAT: 'Afficher le chat',
      HIDE_CHAT: 'Cacher le chat',
      STARTING: 'Départ',
      REJECT_REASON: 'Motif de rejet',
    },
    HISTORY: {
      PRODUCTS: 'Produits',
      ALL: 'Tous',
      HORSE: 'Courses',
      VIRTUAL: 'Virtuel',
      STAKE_VIRTUAL: 'Mise · Virtuel',
      WIN_VIRTUAL: 'Gain · Virtuel',
      CANCELLATION: 'Annulation',
      CLAWBACK: 'Reprise de gain',
      BONUS: 'Bonus',
      VOID: 'Annulé',
      CASHED_OUT: 'Encaissé',
      TICKET: 'Ticket',
      GAME: 'Jeu',
      EVENT: 'Événement',
      PLACED_AT: 'Placé le',
      SETTLED_AT: 'Réglé le',
      SELECTIONS: 'Sélections',
      SELECTION_COUNT: '{{n}} sélection(s)',
      MARKET: 'Marché',
      PICK: 'Choix',
      ODDS: 'Cote',
      STAKE: 'Mise',
      WIN: 'Gain',
      MOVEMENTS: 'Mouvements',
      REVERSED: 'annulé',
      BALANCE_AFTER: 'Solde après',
      RESULT_IN_GAME: 'Résultat : dans le jeu',
      OPEN_GOLDEN_RACE: 'Ouvrir Golden Race',
      DETAILS_UNAVAILABLE: 'Détails indisponibles',
      KIND_HORSE: 'Chevaux',
      KIND_DOG: 'Lévriers',
      KIND_FOOTBALL: 'Football',
      KIND_KENO: 'Keno',
      KIND_NUMBERS: 'Numéros',
      KIND_SPIN2WIN: 'Spin2Win',
      KIND_INSTANT: 'Instantané',
      KIND_CHAMPIONS: 'Champions',
      CATEGORY_BET: 'Mise',
      CATEGORY_WIN: 'Gain',
      CATEGORY_JACKPOT: 'Jackpot',
      CATEGORY_CASHOUT: 'Encaissement',
      CATEGORY_BONUS: 'Bonus',
      CATEGORY_ROLLBACK: 'Annulation',
    },
    AUTH: {
      GENERAL: {
        OR: 'Ou',
        SUBMIT_BUTTON: 'Soumettre',
        NO_ACCOUNT: 'Ne pas avoir de compte?',
        SIGNUP_BUTTON: 'Registre',
        FORGOT_BUTTON: 'Mot de passe oublié',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
        MY_ACCOUNT: 'Mon Compte',
      },
      MENU: {
        ACCOUNT: 'Compte',
        BETS: 'Paris',
        PROFILE: 'Profil',
      },
      ACCOUNT: {
        TRANSACTION: 'Transactions',
        CRYPTO_TRANSACTION: 'Transactions Crypto',
        YOUR_CURRENT_ACCOUNT: 'Transaction du compte à partir de {{date}}',
        RECENT_TRANSACTIONS: 'Transactions récentes sur votre compte de paris.',
        ANY_TRANSACTION: "Vous n'avez pas de transaction.",
        AVAILABLE_FOR_WITHDRAWAL: 'Disponible pour le retrait',
      },
      BET: {
        NO_BET_HISTORY:
          "Aucun historique des paris n'est actuellement disponible.",
      },
      ACTIVATION: {
        TITLE: 'Activation Complète',
        PASSWORD_REQUIRED: 'Veuillez changer le mot de passe.',
        EMAIL_OPTIONAL:
          "L'adresse électronique est optionnelle, mais nous vous recommandons vivement de saisir et d'activer l'adresse électronique que vous utilisez activement. ",
        COMPLETE: 'Activez',
      },
      LOGIN: {
        TITLE: 'Créer un compte',
        BUTTON: 'Sign In',
      },
      FORGOT: {
        FORGOT_PASSWORD: 'Vous avez oublié votre mot de passe?',
        RESET_PASSWORD: 'Réinitialiser le mot de passe',
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.',
      },
      REGISTER: {
        TITLE: 'Créer un compte',
        DESC: 'Saisissez vos informations pour créer votre compte',
        SUCCESS: 'Votre compte a été créé avec succès.',
        TEMPORARILY_LIMITED:
          'Un compte a récemment été créé depuis cet appareil ou ce réseau. Vous pourrez en créer un nouveau à {{time}} (dans {{minutes}} min).',
        TEMPORARILY_LIMITED_HELPER:
          'Vous venez de vous inscrire et vous avez perdu vos identifiants ? Connectez-vous avec le fichier ou l’image que vous avez enregistré.',
        CREATE_BUTTON: 'CRÉER UN COMPTE',
        FIRSTNAME: 'Prénom',
        LASTNAME: 'Nom',
        EMAIL_OPTIONAL: 'Email (facultatif)',
        EMAIL_INVALID: 'Saisissez une adresse email valide.',
        EMAIL_TAKEN: 'Cet email est déjà utilisé.',
        PHONE: 'Numéro de mobile',
        PHONE_PLACEHOLDER: 'ex. 21612345',
        PHONE_INVALID: 'Saisissez 6 à 15 chiffres (précédés éventuellement de +).',
        DOB: 'Date de naissance',
        DAY: 'Jour',
        MONTH: 'Mois',
        YEAR: 'Année',
        DOB_INVALID: 'Cette date n’existe pas — vérifiez le jour et le mois.',
        DOB_HINT: 'Vous devez avoir au moins 18 ans.',
        UNDERAGE: 'Vous devez avoir au moins 18 ans pour vous inscrire.',
        MONTH_1: 'Janvier',
        MONTH_2: 'Février',
        MONTH_3: 'Mars',
        MONTH_4: 'Avril',
        MONTH_5: 'Mai',
        MONTH_6: 'Juin',
        MONTH_7: 'Juillet',
        MONTH_8: 'Août',
        MONTH_9: 'Septembre',
        MONTH_10: 'Octobre',
        MONTH_11: 'Novembre',
        MONTH_12: 'Décembre',
        USERNAME_PATTERN:
          'Uniquement des lettres, chiffres, points, tirets et underscores.',
        USERNAME_TAKEN: "Ce nom d'utilisateur est déjà pris.",
        PASSWORD_MIN: 'Le mot de passe doit comporter au moins 8 caractères.',
        CREATING_TITLE: 'Création de votre compte…',
        CREATING_SUB: 'Un instant — connexion automatique en cours.',
      },
      WELCOME: {
        TITLE: 'Bienvenue sur Racebet365 !',
        BODY: 'Votre compte est prêt. Effectuez votre premier dépôt et commencez à parier sur les courses du jour.',
        CREDS_TITLE: 'Votre compte est prêt !',
        CREDS_SUB: 'Enregistrez vos identifiants maintenant — vous en aurez besoin pour votre prochaine connexion.',
        SAVE_FILE: 'Enregistrer (fichier)',
        SAVE_PICTURE: 'Enregistrer (image)',
        DEPOSIT_NOW: 'Déposer maintenant',
        CLOSE: 'Fermer',
      },
      INPUT: {
        USERNAME: "Nom d'utilisateur",
        FULLNAME: 'Fullname',
        PASSWORD: 'Mot de passe',
        CONFIRM_PASSWORD: 'Confirm Password',
        NEW_PASSWORD: 'Nouveau mot de passe',
        CONFIRM_NEW_PASSWORD: 'Confirmer le nouveau mot de passe',
        EMAIL: 'Adresse e-mail',
        CONFIRM_EMAIL: "Confirmer l'adresse e-mail",
      },
      VALIDATION: {
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Obligatoire',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
        USER_ACCOUNT_UPDATED: 'User account has been successfully updated',
        PASSWORD_WEAK: "Mot de passe trop faible : au moins 8 caractères, pas un mot de passe courant, pas une suite répétée ou séquentielle, et pas votre nom d'utilisateur.",
        MIN_AMOUNT_ERROR: 'Le montant minimum est {{min}} {{currency}}',
        MAX_AMOUNT_ERROR: 'Le montant maximum est {{max}} {{currency}}',
      },
    },
    ALERT: {
      ERROR: 'Erreur',
      INFO: 'Info',
      CONFIRM_ACTION: 'Êtes-vous sûr de vouloir continuer?',
      CONFIRM_CANCEL_WITHDRAWAL: 'Êtes-vous sûr de vouloir annuler ce retrait?',
      TRANSACTION_ID_NOT_FOUND:
        "ID de transaction introuvable. Veuillez contacter l'équipe backend.",
      SUCCESSFULLY_CREATED: 'Le pari a été créé avec succès',
      USERNAME_NOTFOUND: "Nom d'utilisateur introuvable",
      USERNAME_OR_PASSWORD_IS_INCORRECT:
        "Nom d'utilisateur ou le mot de passe est incorrect. Veuillez réessayer.",
      PASSWORD_IS_INCORRECT:
        'Le mot de passe est incorrect. Veuillez réessayer.',
      PASSWORD_MUST_MATCH: 'Les mots de passe doivent correspondre',
      ONLY_VALID_BETS_ARE_ALLOWED: 'Seuls les paris valides sont autorisés',
      RACE_IS_STARTED: 'Pari fermé',
      STAKE_ERROR: 'Stake error',
      INSUFFICIENT_BALANCE: 'Solde insuffisant',
      USER_ACCOUNT_UPDATED: 'User account has been successfully updated',
      SOMETHING_WENT_WRONG: 'Veuillez réessayer',
      USER_CREDENTIALS_SAVED:
        "Les informations d'utilisateur ont été enregistrées en tant qu'image avec succès",
      USER_PASSWORD_UPDATED:
        "Le mot de passe de l'utilisateur a été mis à jour avec succès",
      PASSWORD_SUCCESSFULLY_RESET: 'Your password was successfully reset',
      ACTIVATION_SUCCESSFULLY_COMPLETE_EMAIL:
        "L'activation de l'utilisateur a été effectuée avec succès. Veuillez vérifier votre adresse e-mail",
      ACTIVATION_SUCCESSFULLY_COMPLETE:
        'User activation has been successfully complete',
      MUST_BE_FILLED_CORRECTLY: '{{invalids}} must be filled correctly!',
      VERIFY_YOUR_EMAIL: 'Please verify your email address',
      WELCOME: 'Welcome',
      EMAIL_SUCCESSFULLY_VERIFIED: 'Your email was successfully verified.',
      MONEY_HAS_BEEN_DEPOSITED: 'Money has been deposited into your account.',
      Please_refresh_the_page_to_print:
        'Veuillez actualiser la page pour imprimer.',
      OUT_OF_ORDER: 'Votre compte a été temporairement désactivé.',
    },
    TRACK_RACES: {
      YEARS_OLD_HORSES: 'Pour chevaux de {{year}} ans',
      YEARS_OLD_AND_UPWARD_HORSES: 'Pour chevaux de {{year}} ans et plus',
    },
    QUARTE_RACES: {
      HEADER_TITLE: 'Quarté du jour',
      FINISHED: 'Terminée',
      NO_RACE: "N'existe pas encore",
    },
    Next_Races_Seo: {
      title: 'Paris hippiques | Pariez en ligne avec Racebet365',
      description_content:
        'Retrouvez la liste des prochaines courses disponibles...',
      keywords_content: 'PROCHAINE OPPORTUNITÉ DE PARI',
    },

    HomePage_Seo: {
      title: 'Paris hippiques | Pariez en ligne avec Racebet365',
      description_content:
        "La destination ultime en ligne pour les paris hippiques dans le monde entier ! Large gamme de types de paris pour les événements de courses de chevaux. Paiement en crypto : USDT, BTC, ETH. Rejoignez Racebet365.com aujourd'hui !",
      keywords_content:
        'Paris hippique en ligne, Parier sur les courses hippiques, Site de paris en ligne, Jeu de course de chevaux, Courses hippiques dans monde entier, Courses PMU, paris crypto, USDT, Bitcoin, Ethereum',
    },

    All_Races_Seo: {
      title:
        'Courses Mondiales | Paris hippiques | Pariez en ligne avec Racebet365',
      description_content:
        'Découvrez toutes les courses mondiales et placez vos paris sur Racebet365 ! Nous proposons une large sélection de courses, des courses hippiques aux courses de chiens.',
      keywords_content:
        'courses, courses de chevaux, courses de chiens, Racebet365, paris, Royaume-Uni, États-Unis, Australie, courses populaires, combinaisons, courses mondiales.',
    },

    Pmu_Races_Seo: {
      title: 'Courses PMU | Paris hippiques | Pariez en ligne avec Racebet365',
      description_content:
        'Découvrez les courses PMU et placez vos paris sur Racebet365! Des courses passionnantes vous attendent avec des combinaisons de paris comme Gagnant, Place, Ita, Trita, Jumele, Exacta, Trio, Trifecta, Tierce et Quatre.',
      keywords_content:
        'PMU, course, Racebet365, pari, Gagnant, Place, Ita, Trita, Jumele, Exacta, Trio, Trifecta, Tierce, Quatre.',
    },

    Next_Betting_Seo: {
      title:
        'Courses Suivantes | Paris hippiques | Pariez en ligne avec Racebet365',
      description_content:
        'Ne manquez pas les courses suivantes sur Racebet365 ! Avec nos paris 24/7, vous pouvez suivre des courses du monde entier et placer vos paris sur vos courses préférées.',
      keywords_content:
        'courses suivantes, courses, Racebet365, paris, monde entier, 24/7, suivi, courses favorites.',
    },

    Track_Races_Seo: {
      description_content: ' Retrouvez la liste des courses disponibles dans ',
      keywords_content: 'COURSES VINCENNES ',
    },

    Account_Page_Seo: {
      description_content: 'Consulter l historique de vos transactions',
      keywords_content: 'HISTORIQUE DES TRANSACTIONS',
    },

    Profile_Page_Seo: {
      description_content:
        'Vérifiez les informations de votre compte, changez le mot de passe.',
      keywords_content: 'MON PROFILE',
    },
    Bets_Page_Seo: {
      description_content: 'Consulter votre historique de paris',
      keywords_content: 'HISTORIQUE DES PARIS',
    },
    'Some coupons gave an error': 'Certains coupons ont donné une erreur',
    'Something went wrong.': "Quelque chose s'est mal passé.",
    'Only valid bets are allowed': 'Seuls les paris valides sont autorisés',
    'Total price error': 'Erreur de prix total',
    'Coupon was lost.': 'Le coupon a été perdu.',
    'Insufficient balance': 'Solde insuffisant',
    CRYPTO: {
      MIN_WITHDRAWAL_AMOUNT_NOTE: 'Montant minimum de retrait {{amount}} {{currency}}',
      WILL_BE_ADDED_TO_YOUR_ACCOUNT: 'Sera ajouté à votre compte',
      YOU_WILL_RECEIVE: 'Vous recevrez',
      COUNTRY: 'Pays',
      CURRENCY: 'Devise',
      CRYPTO_WITHDRAWAL_SUCCESSFULLY_CREATED:
        'Le retrait de crypto-monnaie a été créé avec succès',
      SELECT_YOUR_CRYPTO_CURRENCY_WITHDRAWAL_METHOD:
        'Sélectionnez votre méthode de retrait de crypto-monnaie',
      CONFIRM_WITHDRAWAL: 'Confirmer le retrait',
      CONFIRM: 'Confirmer',
      WITHDRAWAL_AMOUNT: 'Montant ({{currency}}):',
      AMOUNT_MIN_MAX: 'Montant (Min {{min}})',
      YOUR_CRYPTO_ADDRESS: 'Votre adresse Crypto',
      PLEASE_NOTE_DIFFER_SLIGHTLY_FROM_THE_ABOVE:
        'Veuillez noter que le taux de change à la fin de la transaction peut différer légèrement du ci-dessus.',
      PLEASE_NOTE_THAT_PROCESSING_YOUR_WITHDRAWAL_MAY_TAKE_UP_TO_30_MINUTES:
        "Veuillez noter que le traitement de votre retrait peut prendre jusqu'à 30 minutes.",
      ONLY_SEND_TETHER_USDT: 'Envoyez UNIQUEMENT Tether (USDT)',
      ONLY_WITHDRAW_TETHER_USDT: 'Retirez UNIQUEMENT Tether (USDT)',
      TO_THIS_DEPOSIT_ADDRESS: 'à cette adresse de dépôt',
      DO_NOT_USE: "N'utilisez PAS",
      DO_NOT_USE_ERC20:
        "ERC20, BEP2, BEP20, OMNI, SOL, ou d'autres standards de réseau car vous pourriez perdre votre dépôt.",
      ONLY_MAKE_DEPOSITS_THROUGH_THE_ETHEREUM_NETWORK_ERC20:
        'Effectuez UNIQUEMENT des dépôts via le réseau Ethereum (ERC20)',
      ONLY_MAKE_DEPOSITS_THROUGH_THE_ETHEREUM_NETWORK:
        'Effectuez UNIQUEMENT des dépôts via le réseau Ethereum',
      ONLY_MAKE_DEPOSITS_THROUGH_THE_TRON_TRC20_NETWORK:
        'Effectuez UNIQUEMENT des dépôts via le réseau Tron (TRC20).',
      DO_NOT_USE_BEP2_BEP20_OMNI_TRC20_SOL:
        "BEP2, BEP20, OMNI, TRC20, SOL ou d'autres standards de réseau car vous pourriez perdre vos fonds.",
      DO_NOT_USE_BEP2_BEP20:
        "BEP2, BEP20, ou d'autres standards de réseau car vous pourriez perdre votre dépôt.",
      THE_USE_OF_CONTRACT_ADDRESSES_IS_NOT_ALLOWED:
        "L'utilisation d'adresses de contrat n'est pas autorisée.",
      ONLY_SEND_ETHEREUM_METH: 'Envoyez UNIQUEMENT Ethereum (mETH)',
      ONLY_SEND_BITCOIN_MICRONBTC: 'Envoyez UNIQUEMENT Bitcoin (µBTC)',
      ONLY_WITHDRAW_BITCOIN_MICRONBTC: 'Retirez UNIQUEMENT Bitcoin (µBTC)',
      ONLY_WITHDRAW_ETHEREUM_METH: 'Retirez UNIQUEMENT Ethereum (mETH)',
      DO_NOT_USE_LIGHTNING_NETWORK:
        "Lightning Network, BEP20, BEP2, ERC20, Polygon ou d'autres standards de réseau car vous pourriez perdre votre dépôt.",
      ONLY_MAKE_DEPOSITS_THROUGH_THE_BTC_NETWORK:
        'Effectuez UNIQUEMENT des dépôts via le réseau BTC.',
      SELECT_YOUR_CRYPTO_CURRENCY_DEPOSIT_METHOD:
        'Sélectionnez votre méthode de dépôt de crypto-monnaie',
      AMOUNT: 'Montant',
      ENTER_AMOUNT: 'Entrez le montant',
      ENTER_YOUR_CRYPTO_ADDRESS: 'Entrez votre adresse crypto',
      MIN_AMOUNT: 'Montant Minimum',
      MAX_AMOUNT: 'Montant Maximum',
      AMOUNT_REQUIRED: 'Le montant est requis',
      AMOUNT_TOO_LOW: 'Le montant est trop bas',
      AMOUNT_TOO_HIGH: 'Le montant est trop élevé',
      RISKS_CONFIRMATION:
        "En cliquant sur le bouton 'Confirmer', vous indiquez que vous acceptez les risques mentionnés ci-dessus.",
      DEPOSIT: 'Dépôt',
      WITHDRAWAL: 'Retrait',
      COPY_ADDRESS_OR_SCAN_QR_CODE: 'Copier l adresse ou scanner le QR Code',
      MINIMUM_DEPOSIT_AMOUNT: 'Montant minimum de dépôt {{amount}}',
      NOTE_ABOUT_THE_EXCHANGE_RATE:
        'Note sur le taux de change: Veuillez noter que le taux de change à la fin de la transaction peut différer légèrement du ci-dessus.',
      TRANSACTION_COMPLETION:
        'Transaction terminée: Veuillez noter que après la fin d une transaction, il peut prendre jusqu à 15 minutes pour que le changement soit visible sur votre solde.',
      VALIDATING_ADDRESS: 'Validation de l adresse',
      ADDRESS_VALID: 'L adresse est valide',
      INVALID_ADDRESS: 'Format d adresse invalide',
      ADDRESS_VALIDATION_ERROR: 'Échec de la validation de l adresse',
      WITHDRAWAL_CANCELLED: 'Le retrait a été annulé avec succès',
      CONFIRM_CANCEL_WITHDRAWAL: 'Êtes-vous sûr de vouloir annuler ce retrait?',
    },
    tnd: {
      provider: {
        telegate_ooredoo: {
          name: 'Ooredoo',
          subtitle: 'Recharge avec carte Ooredoo',
          instructions:
            'Saisissez les codes imprimés sur vos cartes à gratter Ooredoo. Chaque carte est créditée individuellement en quelques secondes.',
        },
        telegate_orange: {
          name: 'Orange',
          subtitle: 'Recharge avec carte Orange',
          instructions:
            'Saisissez les codes de vos cartes à gratter ou tickets électroniques Orange. Chaque carte est créditée automatiquement dès qu’Orange a confirmé son montant — en général en quelques minutes.',
        },
        d17_deposit: {
          name: 'Virement D17',
          subtitle: 'Depuis votre application D17',
          instructions:
            'Envoyez le montant depuis votre application D17 au numéro indiqué, puis saisissez la référence du virement. Votre dépôt est vérifié et crédité automatiquement.',
        },
        flouci_deposit: {
          name: 'Virement Flouci',
          instructions:
            'Envoyez le montant via Flouci, puis téléversez la capture d\'écran de confirmation. Votre dépôt sera crédité après vérification manuelle.',
        },
        izi_card: {
          name: 'Carte bancaire',
          subtitle: 'Visa / Mastercard',
          instructions:
            'Payez par carte bancaire sur une page sécurisée. Votre portefeuille est rechargé instantanément dès la confirmation du paiement.',
        },
        telegate_d17_card: {
          name: 'Carte bancaire',
          subtitle: 'Visa / Mastercard',
          instructions:
            'Payez par carte bancaire sur une page sécurisée. Votre portefeuille est rechargé instantanément dès la confirmation du paiement.',
        },
        d17_withdrawal: {
          name: 'Virement D17',
          subtitle: 'Vers votre compte D17',
          instructions:
            'Indiquez le numéro D17 du bénéficiaire. Le versement est envoyé instantanément, sans frais.',
        },
        flouci_withdrawal: {
          name: 'Virement Flouci',
          instructions:
            'Indiquez le numéro Flouci destinataire. Le virement sera effectué manuellement dans le délai indiqué ci-dessous.',
        },
        mandat_minute: {
          name: 'Mandat Minute',
          subtitle: 'Code de retrait en espèces à La Poste',
          instructions:
            'Indiquez le nom et le téléphone du bénéficiaire. Un code de retrait est émis instantanément pour retirer les espèces dans n\'importe quel bureau de poste.',
        },
        cash_withdrawal: {
          name: 'Retrait en espèces',
          subtitle: 'Espèces livrées chez vous en 6-12h',
          instructions:
            'Saisissez vos informations et notre équipe vous contactera sur WhatsApp pour organiser la livraison des espèces, sous 6 à 12 heures.',
        },
      },
    },
    TND_PAYMENT: {
      DEPOSIT_TITLE: 'Dépôt',
      WITHDRAWAL_TITLE: 'Retrait',
      CHOOSE_DEPOSIT_METHOD: 'Choisissez une méthode de dépôt',
      CHOOSE_WITHDRAWAL_METHOD: 'Choisissez une méthode de retrait',
      SELF_ACCOUNT_REQUIRED:
        'Votre compte n\'a pas été créé par vous-même : il a été ouvert dans un point de vente et reste géré par la boutique. Les dépôts, retraits et transactions en ligne sont réservés aux comptes auto-inscrits.',
      CRYPTO_CARD_LABEL: 'Cryptomonnaie',
      AUTO_BADGE: 'Instantané',
      INSTANT_BADGE: 'Instantané',
      MANUAL_BADGE: 'Manuel',
      // -- Dépôt par carte IZI (Zitouna Pay) --
      IZI_INSTRUCTIONS: 'Payez par carte bancaire. Une page de paiement sécurisée s’ouvre ici — saisissez votre carte pour recharger instantanément.',
      IZI_AMOUNT_LABEL: 'Montant à déposer',
      IZI_SECURE_HINT: 'Transaction sécurisée par ClicToPay. Le montant exact ci-dessus est crédité sur votre solde.',
      IZI_SUBMIT: 'Continuer vers le paiement',
      IZI_OPENING: 'Ouverture du paiement sécurisé…',
      IZI_CHECKOUT_TITLE: 'Paiement carte sécurisé',
      IZI_CHECKOUT_SUB: 'Saisissez votre carte sur la page sécurisée ci-dessous. Cette fenêtre se ferme automatiquement dès la confirmation du paiement.',
      IZI_SECURED_BY: 'Transaction sécurisée par ClicToPay.',
      IZI_LOADING_CHECKOUT: 'Chargement de la page de paiement sécurisée…',
      IZI_WAITING_PAYMENT: 'En attente de votre paiement…',
      IZI_OPEN_NEW_TAB: 'Ouvrir dans un nouvel onglet',
      IZI_RESULT_OK_TITLE: 'Paiement confirmé',
      IZI_RESULT_FAIL_TITLE: 'Paiement non abouti',
      IZI_RESULT_FAIL_BODY: 'Le paiement par carte n’a pas abouti. Aucun montant n’a été crédité. Vous pouvez réessayer.',
      IZI_RESULT_EXPIRED_TITLE: 'Session de paiement expirée',
      IZI_RESULT_EXPIRED_BODY: 'La fenêtre de paiement a expiré avant la fin du paiement. Aucun montant n’a été crédité. Vous pouvez relancer un dépôt.',
      IZI_TIMEOUT_TITLE: 'Traitement en cours',
      IZI_TIMEOUT_BODY: 'Votre paiement prend plus de temps que d’habitude. Si vous avez terminé le paiement, il sera crédité sous peu — consultez vos transactions.',
      IZI_TRY_AGAIN: 'Réessayer',
      IZI_INIT_FAILED: 'Impossible de démarrer le paiement par carte. Veuillez réessayer.',
      IZI_UNAVAILABLE: 'Le dépôt par carte est momentanément indisponible. Réessayez plus tard ou utilisez une autre méthode.',
      // Recharge par carte D17 (MasterCard / La Poste via TeleGate)
      D17CARD_INSTRUCTIONS: 'Paiement sécurisé par carte Visa ou Mastercard, crédité instantanément. Montants entiers uniquement.',
      D17CARD_AMOUNT_LABEL: 'Montant à déposer',
      D17CARD_FEE_HINT: 'Frais bancaires : 0,250 TND + 0,8 %. Votre carte sera débitée d’environ {{charged}} TND.',
      D17CARD_FEE_HINT_GENERIC: 'Frais bancaires : 0,250 TND + 0,8 % du montant.',
      D17CARD_SUBMIT: 'Continuer vers le paiement',
      D17CARD_OPENING: 'Préparation du paiement…',
      D17CARD_PREPARING_TITLE: 'Préparation du paiement',
      D17CARD_PREPARING_BODY: 'Encore quelques instants, votre page de paiement arrive. Gardez cette fenêtre ouverte.',
      D17CARD_PREPARING_SLOW: 'Merci de votre patience, cela prend un peu plus de temps que prévu. Votre page arrive.',
      D17CARD_STEP_SENT: 'Demande reçue',
      D17CARD_STEP_BANK: 'Préparation de votre espace de paiement sécurisé',
      D17CARD_STEP_FORM: 'Paiement par carte',
      D17CARD_CHECKOUT_TITLE: 'Paiement par carte',
      D17CARD_CHARGED_LINE: '{{credited}} TND crédités · {{charged}} TND débités, frais bancaires inclus.',
      D17CARD_SECURED_BY: 'Paiement sécurisé par Mastercard',
      D17CARD_LOADING_CHECKOUT: 'Chargement de la page de paiement…',
      D17CARD_WAITING_PAYMENT: 'En attente du paiement',
      D17CARD_VALID_UNTIL: 'valable jusqu’à {{time}}',
      D17CARD_PAGE_VALID_UNTIL: 'Page de paiement valable jusqu’à {{time}}.',
      D17CARD_CANCEL_PAYMENT: 'Annuler ce paiement',
      D17CARD_CANCELLING: 'Annulation…',
      D17CARD_FRAMED_BODY: 'La page de paiement doit s’ouvrir dans sa propre fenêtre.',
      D17CARD_OPEN_WINDOW: 'Ouvrir la page de paiement',
      D17CARD_WINDOW_OPENED: 'Terminez le paiement dans la nouvelle fenêtre. Cette page se mettra à jour automatiquement.',
      D17CARD_VERIFYING_TITLE: 'Paiement en vérification',
      D17CARD_VERIFYING_BODY: 'Un paiement est en cours de vérification : ce dépôt ne peut plus être annulé. Il sera crédité ou clôturé dans quelques minutes.',
      D17CARD_DO_NOT_CLOSE: 'Finalisation en cours, ne fermez pas cette fenêtre.',
      D17CARD_CLOSE_GUARDED: 'Un paiement par carte est en cours. Pour quitter, utilisez « Annuler le paiement ».',
      D17CARD_RESULT_OK_TITLE: 'Paiement confirmé',
      D17CARD_RESULT_FAIL_TITLE: 'Paiement non abouti',
      D17CARD_RESULT_FAIL_BODY: 'Le paiement n’a pas abouti. Aucun montant n’a été crédité.',
      D17CARD_RESULT_EXPIRED_TITLE: 'Page de paiement expirée',
      D17CARD_RESULT_EXPIRED_BODY: 'La page a expiré sans paiement. Aucun montant n’a été crédité.',
      D17CARD_RESULT_CANCELLED_TITLE: 'Paiement annulé',
      D17CARD_RESULT_CANCELLED_BODY: 'Aucun montant n’a été crédité. Si votre carte a tout de même été débitée, le crédit est automatique dès confirmation.',
      D17CARD_RESULT_CLOSED_BODY: 'Clôturé après vérification : aucun paiement trouvé. Si votre carte a été débitée, contactez le support avec votre référence.',
      D17CARD_REVIEW_TITLE: 'Paiement en vérification',
      D17CARD_REVIEW_BODY: 'Nous vérifions ce paiement. Si votre carte a été débitée, le montant sera crédité. Aucune action requise.',
      D17CARD_TIMEOUT_TITLE: 'Toujours en attente',
      D17CARD_TIMEOUT_BODY: 'Aucun paiement reçu pour l’instant. Suivez ce dépôt dans vos transactions.',
      D17CARD_TIMEOUT_RESUME_BODY: 'Aucun paiement reçu pour l’instant. Vous pouvez reprendre le paiement sur la même page.',
      D17CARD_RESUME_PAYMENT: 'Reprendre le paiement',
      D17CARD_PENDING_RESUME_BODY: 'Votre paiement par carte de {{amount}} TND est en attente. Reprenez-le pour le terminer, ou annulez-le.',
      D17CARD_TRY_AGAIN: 'Réessayer',
      D17CARD_INIT_FAILED: 'Impossible de démarrer le paiement par carte. Veuillez réessayer.',
      D17CARD_UNAVAILABLE: 'Le dépôt par carte est momentanément indisponible. Réessayez plus tard ou utilisez une autre méthode.',
      D17CARD_UNAVAILABLE_UNTIL: 'Le dépôt par carte est momentanément indisponible. Réessayez à {{time}} ou utilisez une autre méthode.',
      D17CARD_BUSY: 'Le paiement par carte est momentanément indisponible. Réessayez dans quelques minutes ou utilisez une autre méthode.',
      D17CARD_BUSY_UNTIL: 'Le paiement par carte est momentanément indisponible. Réessayez à {{time}} ou utilisez une autre méthode.',
      D17CARD_PROCESSING_OVERLAY_TITLE: 'Paiement en cours de traitement',
      D17CARD_PROCESSING_OVERLAY_BODY: 'Quelques secondes. Ne fermez pas cette fenêtre.',
      D17CARD_ACCEPTED_OVERLAY_TITLE: 'Paiement accepté par votre banque',
      D17CARD_ACCEPTED_OVERLAY_BODY: 'Confirmation en cours, quelques secondes. Ne fermez pas cette fenêtre.',
      D17CARD_UNVERIFIED_OVERLAY_TITLE: 'Paiement en cours de vérification',
      D17CARD_UNVERIFIED_OVERLAY_BODY: 'Si votre carte a été débitée, le montant sera crédité automatiquement. Sinon, rien ne vous sera prélevé.',
      D17CARD_UNVERIFIED_FOOTER: 'Ce dépôt reste suivi : vous pouvez fermer cette fenêtre.',
      D17CARD_DAILY_LIMIT: 'Limite quotidienne de paiements par carte atteinte. Réessayez demain ou utilisez une autre méthode.',
      D17CARD_TOO_SOON: 'Patientez un instant avant un nouveau paiement par carte.',
      D17CARD_TOO_SOON_AT: 'Patientez avant un nouveau paiement par carte : réessayez à {{time}}.',
      D17CARD_WHOLE_TND: 'Montants entiers uniquement (20, pas 20,5).',
      D17CARD_GATEWAY_ERROR: 'La page de paiement a signalé un problème. Si vous avez payé, ne payez pas à nouveau : le montant sera crédité une fois confirmé.',
      D17CARD_NO_INDICATOR: 'Paiement accepté, mais le reçu n’a pas pu être lu. Ne payez pas à nouveau ; si le montant n’est pas crédité dans quelques minutes, contactez le support avec votre référence.',
      // -- Dépôt D17 (réclamation automatique) --
      D17_CLAIM_INSTRUCTIONS: 'Envoyez l’argent depuis votre application D17 au numéro ci-dessous, puis saisissez les détails du virement.',
      D17_SEND_TO: 'Envoyez votre virement D17 à ce numéro',
      D17_TARGET_ROTATES_LEAD: 'Ce numéro change régulièrement.',
      D17_TARGET_ROTATES_BODY: 'Vérifiez-le ici avant chaque envoi — un ancien numéro ne sera pas crédité.',
      D17_TARGET_LOADING: 'Obtention d’un numéro de dépôt…',
      D17_CANT_RECEIVE: 'Changer de numéro',
      D17_TARGETS_EXHAUSTED: 'Vous avez vu tous les numéros disponibles — retour au premier.',
      D17_AMOUNT_LABEL: 'Montant envoyé (TND)',
      D17_SENDER_PHONE_LABEL: 'Votre numéro D17',
      D17_SENDER_PHONE_PLACEHOLDER: 'Le numéro depuis lequel vous avez envoyé',
      D17_SENDER_PHONE_REQUIRED: 'Votre numéro D17 est requis.',
      D17_AUTORISATION_LABEL: 'Référence du virement',
      D17_AUTORISATION_PLACEHOLDER: 'ex. 977061',
      D17_AUTORISATION_HINT: 'Le numéro d’autorisation/référence affiché dans votre application D17 après le virement.',
      D17_AUTORISATION_REQUIRED: 'La référence du virement est requise.',
      D17_AUTORISATION_INVALID: 'La référence doit comporter exactement 6 chiffres.',
      AMOUNT_DIGITS_ONLY: 'Saisissez un nombre entier (chiffres uniquement).',
      D17_ADJUSTED_UNDER: 'Nous avons crédité le montant exact reçu, qui était inférieur à celui saisi.',
      D17_ADJUSTED_OVER: 'Nous avons crédité le montant exact reçu, qui était supérieur à celui saisi.',
      D17_RESULT_THROTTLED_BODY: 'Trop de tentatives échouées. Veuillez patienter quelques minutes avant de réessayer.',
      // -- garde-fou : un seul dépôt en attente --
      PENDING_GATE_TITLE: 'Vous avez un dépôt en attente',
      PENDING_GATE_BODY: 'Terminez ou annulez votre dépôt {{method}} en cours avant d’en commencer un nouveau.',
      PENDING_GATE_CANCEL: 'Annuler le dépôt en attente',
      PENDING_GATE_CANCELLING: 'Annulation…',
      PENDING_GATE_VIEW: 'Le voir dans mes transactions',
      // -- verrouillage après 3 dépôts échoués --
      LOCKED_TITLE: 'Dépôts momentanément suspendus',
      LOCKED_BODY: 'Vos {{threshold}} dernières tentatives de dépôt ont échoué, les dépôts sont donc suspendus pour un court moment. Votre argent est en sécurité — rien n’a été prélevé de votre portefeuille.',
      LOCKED_RESUME_AT: 'Vous pourrez déposer à nouveau à {{time}}',
      LOCKED_NOTICE: 'Les dépôts sont suspendus pendant 1 heure. Vous pourrez déposer à nouveau à {{time}}.',
      ATTEMPT_X_OF_N: 'Tentative échouée {{streak}} sur {{threshold}}.',
      ATTEMPTS_REMAINING: '{{remaining}} tentative(s) restante(s) avant la suspension des dépôts pendant 1 heure.',
      LAST_ATTEMPT_WARNING: 'Attention — encore un dépôt échoué et les dépôts seront suspendus pendant 1 heure. Vérifiez bien vos informations avant de valider.',
      REJECTED_STRIKE_NOTE: 'À savoir : des dépôts échoués ou rejetés à répétition suspendent temporairement les nouveaux dépôts pendant 1 heure.',
      CONTACT_SUPPORT: 'Contacter le support',
      DEPOSIT_FAILED_NOTHING_TAKEN: 'Aucun montant n’a été prélevé de votre portefeuille pour ce dépôt.',
      D17_SUBMIT: 'Vérifier mon virement',
      D17_PROCESSING_TITLE: 'Vérification de votre virement…',
      D17_PROCESSING_BODY: 'Nous vérifions votre virement D17 dans le journal du compte. Cela prend quelques secondes.',
      D17_RESULT_OK_TITLE: 'Dépôt crédité',
      D17_RESULT_REVIEW_TITLE: 'En cours de vérification',
      D17_RESULT_REVIEW_BODY: 'Nous avons reçu les détails de votre virement mais une vérification manuelle rapide est nécessaire (l’expéditeur ne correspondait pas). Votre dépôt sera crédité une fois vérifié.',
      D17_RESULT_FAIL_TITLE: 'Virement non vérifié',
      D17_RESULT_FAIL_BODY: 'Nous n’avons pas pu vérifier ce virement. Vérifiez la référence et le numéro de l’expéditeur, ou contactez le support.',
      D17_UNAVAILABLE: 'Les dépôts D17 sont momentanément indisponibles. Réessayez plus tard ou utilisez une autre méthode.',
      // -- Retrait instantané (automatique) --
      AUTO_D17_INSTRUCTIONS: 'Saisissez le numéro D17 du bénéficiaire. Le versement est envoyé instantanément.',
      AUTO_MANDAT_INSTRUCTIONS: 'Saisissez les informations du bénéficiaire. Un code de retrait est émis instantanément pour un retrait en espèces dans n’importe quel bureau de poste.',
      WITHDRAWABLE_BALANCE: 'Solde retirable',
      WITHDRAWAL_AMOUNT_LABEL: 'Montant à retirer (TND)',
      WITHDRAWAL_FEE_NET: 'Frais {{fee}} TND — le bénéficiaire reçoit {{net}} TND',
      RECIPIENT_NAME_LABEL: 'Nom complet du bénéficiaire',
      RECIPIENT_NAME_PLACEHOLDER: 'Tel que sur la pièce d’identité (retrait au bureau de poste)',
      RECIPIENT_NAME_REQUIRED: 'Le nom complet du bénéficiaire est requis.',
      AUTO_D17_NOT_REGISTERED_TITLE: 'Ce numéro n’est pas sur D17',
      AUTO_D17_NOT_REGISTERED_BODY: 'Le numéro du bénéficiaire n’est pas inscrit sur D17, le virement n’a donc pas pu être effectué — rien n’a été envoyé. Vérifiez le numéro et réessayez, ou envoyez l’argent en mandat minute à retirer au bureau de poste.',
      USE_MANDAT_INSTEAD: 'Envoyer en mandat minute à la place',
      MANDAT_SWITCH_HINT: 'Retrait en espèces au bureau de poste — le bénéficiaire reçoit {{net}} TND (frais de {{fee}} TND).',
      RECIPIENT_PHONE_PLACEHOLDER: 'Numéro tunisien à 8 chiffres',
      RECIPIENT_PHONE_REQUIRED: 'Le téléphone du bénéficiaire est requis.',
      AUTO_WITHDRAWAL_SUBMIT: 'Retirer maintenant',
      AUTO_WITHDRAWAL_PROCESSING_TITLE: 'Traitement de votre retrait…',
      AUTO_WITHDRAWAL_PROCESSING_BODY: 'Votre versement est en cours d’envoi. Cela se termine généralement en quelques secondes.',
      AUTO_WITHDRAWAL_OK_TITLE: 'Retrait effectué',
      AUTO_D17_PAID: 'Envoyé au bénéficiaire',
      D17_AUTH_CODE: 'Numéro d’autorisation',
      D17_AUTH_CODE_HINT: 'Autorisation du transfert — le bénéficiaire voit ce numéro dans son application D17.',
      MANDAT_CLAIM_HINT: 'Communiquez ce code au bénéficiaire — il retire les espèces dans n’importe quel bureau de poste.',
      MANDAT_CLAIM_CODE: 'Code de retrait',
      MANDAT_NET: 'Montant à retirer',
      MANDAT_VALID_UNTIL: 'À retirer avant le',
      WD_STAGE_BALANCE: 'Vérification de votre solde',
      WD_STAGE_MANDAT_EMIT: 'Émission du mandat à La Poste',
      WD_STAGE_MANDAT_CODE: 'Génération du code',
      WD_STAGE_D17_SEND: 'Envoi vers le compte D17',
      WD_STAGE_D17_CONFIRM: 'Confirmation du transfert',
      WD_DO_NOT_CLOSE: 'Ne fermez pas cette fenêtre.',
      WD_SLOW_RAIL: 'Le réseau met un peu plus de temps que d’habitude — votre retrait est bien enregistré, restez sur cette page.',
      MANDAT_ISSUED_TITLE: 'Mandat émis',
      MANDAT_WHO_CIN: 'CIN requise',
      MANDAT_IMPORTANT_LINK: 'Important — à lire',
      MANDAT_IMPORTANT_HIDE: 'Important — masquer',
      MANDAT_IMPORTANT_BODY: 'Seul {{name}} peut retirer ce mandat. Le guichet vérifie sa carte d’identité (CIN) au nom exact indiqué : sans CIN valide, le retrait ne peut pas être effectué.',
      COPY_CODE: 'Copier le code',
      CODE_COPIED: 'Code copié ✓',
      D17_SENT_TO_HEADER: 'Envoyé au compte D17',
      RECIPIENT_NUMBER: 'Numéro destinataire',
      AMOUNT_RECEIVED_ROW: 'Montant reçu',
      STATUS_ROW: 'Statut',
      STATUS_CREDITED: 'Crédité',
      MANDAT_CARD_TITLE: 'Retrait en espèces à la poste',
      MANDAT_ID_HINT: 'Le bénéficiaire présente ce code avec sa pièce d’identité dans n’importe quel bureau de poste.',
      COPY: 'Copier',
      COPIED: 'Copié !',
      AUTO_WITHDRAWAL_FAIL_TITLE: 'Retrait échoué',
      AUTO_WITHDRAWAL_FAIL_BODY: 'Le versement n’a pas pu être effectué.',
      AUTO_WITHDRAWAL_REFUNDED: 'Le montant a été recrédité sur votre portefeuille.',
      AUTO_WITHDRAWAL_REVIEW_TITLE: 'Retrait en vérification',
      AUTO_WITHDRAWAL_REVIEW_BODY: 'Votre retrait est en cours de vérification par notre équipe. Vous serez informé une fois traité.',
      AUTO_WITHDRAWAL_REVIEW_RESERVED: 'Ce montant est réservé sur votre portefeuille jusqu’à la fin de la vérification (ou votre annulation).',
      AUTO_WITHDRAWAL_TRY_AGAIN: 'Réessayer',
      AUTO_WITHDRAWAL_TIMEOUT_TITLE: 'Traitement en cours',
      AUTO_WITHDRAWAL_TIMEOUT_BODY: 'Votre retrait prend plus de temps que d’habitude. Consultez vos transactions pour le statut final.',
      WITHDRAWAL_DAILY_CAP: 'Vous avez atteint votre limite de retrait quotidienne. Réessayez demain.',
      WITHDRAWAL_PENDING_EXISTS: 'Vous avez déjà un retrait en cours de traitement — attendez qu’il se termine avant d’en demander un autre.',
      WITHDRAWAL_TOO_SOON: 'Veuillez patienter une minute avant de demander un autre retrait.',
      WITHDRAWAL_INSUFFICIENT: 'Solde retirable insuffisant pour ce montant.',
      STATUS_PROCESSING: 'En cours',
      STATUS_AWAITING_REVIEW: 'En vérification',
      RETRY: 'Réessayer',
      RANGE_TND: '{{min}} - {{max}} TND',
      LOADING_METHODS: 'Chargement des méthodes de paiement…',
      NO_METHODS: 'Aucune méthode de paiement disponible.',
      COMING_SOON_TAG: 'Bientôt disponible',
      COMING_SOON_AUTO_BODY: 'Les dépôts instantanés via cette méthode arrivent très bientôt. En attendant, choisissez une autre méthode de dépôt.',
      PICK_ANOTHER_METHOD: 'Choisir une autre méthode',

      // Dépôt par carte de recharge Telegate (Phase 1c)
      TND: 'TND',
      SCRATCH_HELP_TITLE: 'Comment ça marche',
      SCRATCH_HELP_STEP1: 'Grattez la zone argentée de votre carte Ooredoo pour révéler le code de recharge.',
      SCRATCH_HELP_STEP2: 'Touchez « Scanner les cartes » pour le lire avec l’appareil photo, ou saisissez le code à 14 chiffres manuellement.',
      SCRATCH_HELP_STEP3: 'Saisissez le montant total et validez — votre solde est crédité automatiquement.',
      SCRATCH_HELP_CODE_HINT: 'Utilisez le code à 14 chiffres dans l’encadré (ex. 0743 0951 1566 39) — pas le numéro de série imprimé sous le code-barres.',
      SCRATCH_HELP_IMG_ALT: 'Exemple de cartes de recharge Ooredoo',
      SCRATCH_INSTRUCTIONS: 'Rechargez avec vos cartes Ooredoo — crédit automatique après vérification.',
      // Orange variants (resolved as <KEY>_ORANGE, falling back to <KEY>).
      // Orange is codes-only: the operator measures each card's amount.
      SCRATCH_INSTRUCTIONS_ORANGE: 'Rechargez avec vos cartes Orange — crédit automatique dès qu’Orange a confirmé le montant de chaque carte.',
      SCRATCH_HELP_STEP1_ORANGE: 'Grattez la zone de votre carte Orange — ou ouvrez votre ticket électronique Orange — pour faire apparaître le code de recharge à 14 chiffres.',
      SCRATCH_HELP_STEP2_ORANGE: 'Saisissez chaque code à 14 chiffres, une carte par ligne.',
      SCRATCH_HELP_STEP3_ORANGE: 'Indiquez le total de vos cartes et validez — Orange mesure le montant de chaque carte et votre solde est crédité automatiquement.',
      SCRATCH_HELP_CODE_HINT_ORANGE: 'Carte physique : le code est imprimé en 4 groupes (ex. 9264 3246 9666 42) — ni le numéro de série, ni les chiffres du code-barres. Ticket électronique : le code, ce sont les 14 chiffres imprimés d’un seul bloc — pas le numéro de série à 12 chiffres imprimé juste en dessous.',
      SCAN_HINT_ORANGE: 'Utilisez l’appareil photo ou choisissez une photo — nette et bien éclairée. Seuls les codes sont lus : saisissez le total vous-même, Orange mesure le montant de chaque carte.',
      SCRATCH_PROCESSING_BODY_ORANGE: 'Orange valide vos cartes. Comptez de quelques secondes à quelques minutes — restez ici, votre solde se met à jour tout seul.',
      SCRATCH_TIMEOUT_BODY_ORANGE: 'Vos cartes sont toujours en cours de validation — rien n’est perdu. Retrouvez-les dans Portefeuille ; votre solde est crédité automatiquement dès confirmation.',
      SCRATCH_AMOUNT_LABEL: 'Montant total (TND)',
      // Providers whose amount is NOT asked (amount_mode 'auto' — Orange: the
      // cards print no value). {{operator}} is the provider's display name.
      SCRATCH_AMOUNT_AUTO_NOTE: 'Le montant est détecté automatiquement par {{operator}} après validation de chaque carte.',
      SCRATCH_HELP_STEP3_AUTO: 'Validez — aucun montant à saisir : {{operator}} mesure le montant de chaque carte et votre solde est crédité automatiquement.',
      SCAN_HINT_AUTO: 'Utilisez l’appareil photo ou choisissez une photo — nette et bien éclairée. Seuls les codes sont lus : {{operator}} détecte le montant de chaque carte.',
      SCRATCH_CODES_LABEL: 'Codes des cartes de recharge',
      SCRATCH_CODES_HINT: 'Ajoutez jusqu’à 10 cartes. Chaque code se trouve sous la zone à gratter.',
      SCRATCH_CODE_PLACEHOLDER: 'Code de la carte',
      SCRATCH_CODE_REQUIRED: 'Saisissez le code de la carte.',
      SCRATCH_CODE_INVALID: 'Le code doit contenir 14 chiffres.',
      SCRATCH_CODE_DUPLICATE: 'Ce code est déjà saisi. Chaque carte de recharge ne peut être utilisée qu’une seule fois.',
      SCRATCH_ADD_CODE: 'Ajouter une carte',
      SCRATCH_REMOVE_CODE: 'Supprimer cette carte',
      SCRATCH_CARD: 'Carte',
      SCRATCH_SUBMIT: 'Recharger maintenant',
      SCRATCH_PROCESSING_TITLE: 'Votre recharge est en route',
      SCRATCH_PROCESSING_BODY: 'Cela prend généralement quelques secondes. Veuillez garder cette fenêtre ouverte.',
      SCRATCH_STATUS_PENDING: 'En attente',
      SCRATCH_STATUS_PROCESSING: 'En cours',
      SCRATCH_STATUS_COMPLETED: 'Validée',
      SCRATCH_STATUS_FAILED: 'Refusée',
      // A held card is being verified — never "rejected", whatever its code.
      SCRATCH_STATUS_NEEDS_REVIEW: 'En cours de vérification',
      // Telegate's per-card phase while a card is in flight (Orange/TT queue).
      SCRATCH_PHASE_QUEUED: 'En attente',
      SCRATCH_PHASE_CHECKING: 'Vérification…',
      SCRATCH_PHASE_MEASURING: 'Acceptée ✓ · montant en cours',
      SCRATCH_QUEUE_LINE: 'Votre tour arrive · environ {{eta}} s',
      SCRATCH_QUEUE_LINE_MIN: 'Votre tour arrive · environ {{minutes}} min',
      SCRATCH_QUEUE_AHEAD_ONE: '1 carte avant la vôtre',
      SCRATCH_QUEUE_AHEAD: '{{ahead}} cartes avant la vôtre',
      SCRATCH_NO_LANE_LINE: 'Encore un instant — vos cartes sont bien enregistrées et rien n’a été utilisé.',
      SCRATCH_HOLD_AUTO_BODY: 'Carte acceptée ! Orange confirme le montant — encore 1 à 3 minutes, on s’en occupe.',
      SCRATCH_REJECTED_NOTICE: 'Certaines cartes n’ont pas été acceptées :',
      SCRATCH_REJECTED_REASON_COMPLETED: 'Déjà utilisée',
      SCRATCH_REJECTED_REASON_IN_PROGRESS: 'En cours de traitement — réessayez plus tard',
      SCRATCH_REJECTED_REASON_UNDER_REVIEW: 'En cours de vérification',
      SCRATCH_REJECTED_REASON_FAILED: 'Temporairement bloquée — réessayez plus tard',
      SCRATCH_REJECTED_REASON_DUPLICATE_IN_REQUEST: 'Saisie en double',
      SCRATCH_REJECTED_REASON_NO_ELIGIBLE_SIMS: 'Aucune ligne libre — non utilisée, réessayez plus tard',
      SCRATCH_RESULT_OK_TITLE: 'Dépôt crédité 🎉',
      SCRATCH_RESULT_FAIL_TITLE: 'Échec du dépôt',
      SCRATCH_RESULT_FAIL_BODY: 'Aucune de vos cartes n’a pu être validée. Vérifiez les codes et réessayez.',
      // A failure that never counted as a strike (lock-exempt): no "check your
      // codes", no "same codes" promise — a manual check may have found a card used.
      SCRATCH_RESULT_FAIL_NO_STRIKE_BODY: 'Ce dépôt n’a pas pu aboutir. Rien n’est compté contre vous : il ne s’agit pas d’une tentative échouée.',
      SCRATCH_RESULT_REVIEW_TITLE: 'Cartes en vérification',
      SCRATCH_RESULT_REVIEW_BODY: 'Vos cartes sont en cours de vérification. Rien n’est perdu : le crédit arrive automatiquement dès confirmation, parfois un peu plus tard. Vous pouvez déposer autrement entre-temps.',
      SCRATCH_RESULT_REVIEW_AUTO_BODY: 'Presque terminé ! Vos cartes sont acceptées, le montant est en cours de confirmation. Votre solde sera crédité automatiquement dans quelques minutes — suivez-le dans Portefeuille.',
      SCRATCH_RESULT_NO_LINE_TITLE: 'Service momentanément indisponible',
      SCRATCH_RESULT_NO_LINE_BODY: 'Vos cartes n’ont pas été utilisées — réessayez dans quelques minutes avec les mêmes codes. Cela ne compte pas comme une tentative échouée.',
      SCRATCH_RESULT_RETRY_TITLE: 'Nouvelle tentative automatique',
      SCRATCH_RESULT_RETRY_BODY: 'Nouvelle tentative en cours — rien à faire de votre côté, et cela ne compte pas comme un échec.',
      SCRATCH_RESULT_INFRA_TITLE: 'Service momentanément indisponible',
      SCRATCH_RESULT_INFRA_BODY: 'Vos cartes n’ont pas été utilisées — réessayez dans quelques minutes avec les mêmes codes. Cela ne compte pas comme une tentative échouée.',
      SCRATCH_ERROR_NOT_USED: 'Non utilisée — réessayez dans quelques minutes',
      DEPOSIT_AUTO_RETRY_BODY: 'Une carte n’a pas été consommée par l’opérateur : elle a été re-soumise automatiquement dans un nouveau dépôt.',
      DEPOSIT_AUTO_RETRY_CHILD_BODY: 'Ce dépôt est la re-soumission automatique d’une carte que l’opérateur n’avait pas consommée.',
      SCRATCH_CREDITED: 'Crédité sur votre portefeuille :',
      SCRATCH_MISMATCH: 'Vous avez saisi {{declared}} TND mais {{detected}} TND ont été détectés sur vos cartes. Votre portefeuille a été crédité sur la base du montant détecté.',
      SCRATCH_MISMATCH_OVER_CREDITED: 'Vous avez saisi {{declared}} TND mais {{detected}} TND ont été détectés sur vos cartes. Votre portefeuille a été crédité sur la totalité du montant détecté.',
      SCRATCH_MISMATCH_CAPPED: 'Vous avez saisi {{declared}} TND mais {{detected}} TND ont été détectés sur vos cartes. Votre portefeuille a été crédité de {{declared}} TND — notre équipe vérifie automatiquement la différence.',
      // Frais (par méthode, configurés sur la ligne du fournisseur)
      FEE_LABEL: 'Frais',
      FEE_PERCENT_NOTE: '{{percent}}% de frais déduits',
      FEE_PERCENT_ESTIMATE: 'Frais {{percent}}% — vous recevrez environ {{net}} TND.',
      FEE_DETECTED_GROSS: 'Cartes détectées',
      FEE_NET_CREDITED: 'Crédité au solde',
      FEE_NET_RECEIVED: 'Vous recevez',
      WITHDRAWAL_NET_HINT: 'Vous recevrez {{net}} TND (frais : {{fee}} TND).',
      SCRATCH_NEW_DEPOSIT: 'Nouveau dépôt',
      SCRATCH_TIMEOUT_TITLE: 'Traitement en cours',
      SCRATCH_TIMEOUT_BODY: 'Cela prend plus de temps que prévu. Vous pouvez suivre le résultat dans votre onglet Portefeuille.',
      SCRATCH_CARD_DETAILS: 'Cartes de recharge',
      SCRATCH_SUMMARY_LABEL: 'Récapitulatif',
      SCRATCH_SUMMARY: '{{completed}} carte(s) sur {{total}} créditée(s) · {{amount}} TND au total',
      SCRATCH_ERROR_INVALID_CODE: 'Code invalide',
      SCRATCH_ERROR_ALREADY_USED: 'Déjà utilisé',
      SCRATCH_ERROR_GENERIC: 'N’a pas pu être traité',
      SCRATCH_ERROR_CARD_REFUSED: 'Refusée par l’opérateur',
      SCRATCH_ERROR_NO_LINE: 'Non utilisée — réessayez dans quelques minutes',
      SCRATCH_ERROR_ALL_SIMS_FAILED: 'L’opérateur n’a pas pu traiter cette carte — réessayez plus tard',
      SCRATCH_ERROR_AMOUNT_UNVERIFIED: 'Montant non confirmé par l’opérateur — contactez le support',
      SCAN_CARDS: 'Scanner mes cartes',
      SCAN_SUBLABEL: 'Les codes se remplissent automatiquement',
      SCAN_TAKE_PHOTO: 'Prendre une photo',
      SCAN_FROM_GALLERY: 'Depuis la galerie',
      TYPE_MANUALLY: 'Saisir les codes manuellement',
      SCANNING: 'Lecture…',
      SCAN_HINT: 'Utilisez l’appareil photo ou choisissez une photo — nette et bien éclairée ; plusieurs cartes à la fois, c’est possible.',
      SCAN_DETECTED: '{{count}} code(s) détecté(s) — veuillez vérifier chacun.',
      SCAN_NO_CODES: 'Aucun code détecté. Assurez-vous que le code est visible et bien éclairé, puis reprenez la photo — ou saisissez-le ci-dessous.',
      SCAN_FAILED: 'Échec du scan. Réessayez ou saisissez les codes manuellement.',
      SCAN_CAP_REACHED: 'Vous avez atteint la limite de scans pour aujourd’hui. Veuillez saisir les codes manuellement.',
      SCAN_IMAGE_TOO_LARGE: 'Cette image est trop volumineuse. Reprenez la photo et réessayez.',
      SCAN_CAMERA_HELP: 'La caméra ne fonctionne pas ? Autorisez l’accès à la caméra pour votre navigateur dans les réglages du téléphone (ex. Réglages → Safari ou Chrome → Caméra), ou choisissez une photo existante depuis votre galerie.',
      TOO_MANY_CARDS_BLOCK: '{{count}} cartes détectées — le maximum par dépôt est {{max}}. Veuillez en retirer {{over}}.',
      SCAN_LOW_CONFIDENCE: 'Lecture incertaine — veuillez vérifier ce code.',
      SCAN_VERIFY_CODE: 'Lu sur votre photo — vérifiez-le par rapport à votre carte.',
      SCRATCH_AMOUNT_AUTO: 'Total détecté à partir de vos cartes — merci de le vérifier.',
      SCRATCH_AMOUNT_UNREADABLE: 'Impossible de lire le montant d’une carte — rescannez-la de plus près, ou saisissez le total vous-même.',

      AMOUNT_LABEL: 'Montant (TND)',
      AMOUNT_PLACEHOLDER: 'ex. 50',
      AMOUNT_HINT_RANGE: 'Entre {{min}} et {{max}} TND',
      AMOUNT_REQUIRED: 'Le montant est requis.',
      AMOUNT_TOO_LOW: 'Minimum {{min}} TND.',
      AMOUNT_TOO_HIGH: 'Maximum {{max}} TND.',
      AMOUNT_NOT_NUMERIC: 'Saisissez un montant valide.',
      AMOUNT_NOT_MULTIPLE: 'Le montant doit être un multiple de {{multiple}} TND (ex. 150, 160, 170…).',
      D17_PHONE_LABEL: 'Votre numéro D17',
      D17_PHONE_PLACEHOLDER: 'ex. 99999999',
      D17_AUTH_LABEL: 'Code d\'autorisation (optionnel)',
      D17_AUTH_PLACEHOLDER: 'Code d\'autorisation D17 si affiché',
      D17_AUTH_HELP_LINK: 'Où le trouver ?',
      D17_AUTH_HELP_CAPTION: 'Après l\'envoi de l\'argent dans l\'application D17, l\'écran de confirmation affiche votre numéro d\'autorisation (encadré en rouge ci-dessus).',
      D17_AUTH_HELP_IMG_ALT: 'Écran de confirmation D17 avec le numéro d\'autorisation encadré',
      SECTION_PAYMENT_DETAILS: 'Votre paiement',
      SECTION_PAYMENT_PROOF: 'Preuve de paiement',
      FLOUCI_PHONE_LABEL: 'Votre numéro Flouci',
      FLOUCI_NAME_LABEL: 'Nom du compte Flouci',
      FLOUCI_NAME_PLACEHOLDER: 'Nom complet enregistré sur Flouci',
      FLOUCI_REFERENCE_LABEL: 'Référence de transaction',
      FLOUCI_REFERENCE_PLACEHOLDER: 'Référence affichée par Flouci après l\'envoi',
      PHONE_INVALID: 'Saisissez un numéro de téléphone tunisien valide.',
      NAME_INVALID: 'Saisissez un nom valide (lettres uniquement, sans chiffres).',

      CAPTURE_LABEL: 'Capture de confirmation',
      CAPTURE_HINT: 'Téléversez une photo claire de la confirmation. JPG, PNG, HEIC ou PDF, jusqu\'à 4 Mo.',
      CAPTURE_PICK: 'Prendre une photo ou choisir un fichier',
      CAPTURE_RETAKE: 'Remplacer',
      CAPTURE_REQUIRED: 'Une capture de confirmation est requise.',
      CAPTURE_TYPE_NOT_ALLOWED: 'Type de fichier non autorisé. Utilisez JPG, PNG, HEIC ou PDF.',
      CAPTURE_TOO_LARGE: 'Fichier trop volumineux. Maximum 4 Mo.',
      CAPTURE_UPLOADING: 'Envoi… {{percent}}%',
      CAPTURE_UPLOADED: 'Envoyé',
      CAPTURE_FAILED: 'Échec du téléversement. Réessayez.',

      RECIPIENT_PHONE_LABEL: 'Numéro destinataire',
      RECIPIENT_PHONE_HINT: 'Le numéro qui recevra l\'argent.',
      RECIPIENT_FULL_NAME_LABEL: 'Nom complet du destinataire',
      RECIPIENT_FULL_NAME_HINT: 'Le nom enregistré chez Mandat Minute.',
      MIN_PROCESSING_TIME: 'Délai de traitement: {{min}}-{{max}} minutes',
      MIN_PROCESSING_TIME_OPEN: 'Délai de traitement: environ {{min}} minutes',
      // -- Retrait en cash --
      CASH_NAME_HINT: 'La personne qui reçoit les espèces (comme sur sa pièce d\'identité).',
      CASH_CONTACT_PHONE_LABEL: 'Votre numéro WhatsApp',
      CASH_CONTACT_PHONE_HINT: 'Notre équipe vous contacte sur ce numéro pour organiser la livraison.',
      CASH_REGION_LABEL: 'Région',
      CASH_REGION_PLACEHOLDER: 'Choisissez votre région',
      CASH_DELIVERY_WINDOW: 'Les espèces sont livrées sous 6 à 12 heures.',
      WITHDRAWAL_REQUIRED_BALANCE_NOTE:
        'Les retraits sont payés depuis votre solde retirable. Pariez pour le faire grandir depuis votre solde de dépôt.',

      SUBMIT_DEPOSIT: 'Soumettre le dépôt',
      SUBMIT_WITHDRAWAL: 'Soumettre le retrait',
      SUBMITTING: 'Envoi…',
      PHASE_CREATING: 'Création de votre dépôt…',
      PHASE_UPLOADING: 'Envoi de votre preuve…',
      PHASE_CONFIRMING: 'Finalisation…',
      DEPOSIT_SUBMITTED_TITLE: 'Dépôt soumis',
      DEPOSIT_SUBMITTED_BODY: 'Votre dépôt sera crédité après vérification du virement. Vous pouvez le suivre dans votre onglet Portefeuille.',
      WITHDRAWAL_SUBMITTED_TITLE: 'Retrait soumis',
      WITHDRAWAL_SUBMITTED_BODY: 'Votre solde retirable a été retenu. Le virement sera libéré après approbation.',
      VIEW_TRANSACTIONS: 'Voir mes transactions',
      MAKE_ANOTHER: 'Nouveau',

      WALLET_TAB_TITLE: 'Transactions Portefeuille',
      DIRECTION: 'Direction',
      ALL: 'Toutes',
      DEPOSIT_FILTER: 'Dépôts',
      WITHDRAWAL_FILTER: 'Retraits',
      STATUS: 'Statut',
      METHOD: 'Méthode',
      AMOUNT: 'Montant',
      DATE: 'Date',
      EMPTY_TRANSACTIONS: 'Aucune transaction.',
      VIEW_DETAIL: 'Voir',
      STATUS_PENDING: 'En attente',
      STATUS_COMPLETED: 'Terminé',
      STATUS_REJECTED: 'Rejeté',
      STATUS_CANCELLED: 'Annulé',
      STATUS_FAILED: 'Échoué',
      STATUS_EXPIRED: 'Expiré',

      DETAIL_TITLE: 'Détails de la transaction',
      REQUEST_CODE: 'Référence',
      AMOUNT_REQUESTED: 'Montant demandé',
      AMOUNT_CREDITED: 'Montant crédité',
      AMOUNT_DECLARED: 'Montant saisi',
      // Orange deposit (amount not asked) not credited yet: no figure to show.
      AMOUNT_AUTO_PENDING: 'En cours de validation',
      BALANCE_BEFORE: 'Solde avant',
      BALANCE_AFTER: 'Solde après',
      WITHDRAWABLE_BEFORE: 'Retirable avant',
      WITHDRAWABLE_AFTER: 'Retirable après',
      SUBMITTED_AT: 'Soumise le',
      COMPLETED_AT: 'Terminée le',
      REJECTED_AT: 'Rejetée le',
      CANCELLED_AT: 'Annulée le',
      REJECT_REASON: 'Raison du rejet',
      WITHDRAWAL_REFERENCE: 'Référence (votre argent a été envoyé avec ce code)',
      WITHDRAWAL_SENDER_PHONE: 'Envoyé depuis',
      USER_DATA_TITLE: 'Vous avez soumis',
      CANCEL_WITHDRAWAL: 'Annuler le retrait',
      CANCEL_DEPOSIT: 'Annuler le dépôt',
      CONFIRM_CANCEL_DEPOSIT: 'Annuler ce dépôt en attente ? Si le paiement a déjà été effectué, il sera crédité à la place.',
      DEPOSIT_ALREADY_LANDED: 'Votre paiement était déjà arrivé — il a été crédité sur votre portefeuille.',
      CONFIRM_CANCEL: 'Confirmez-vous l\'annulation de ce retrait? Votre solde retenu sera remboursé.',
      CONFIRM_CANCEL_YES: 'Oui, annuler',
      CONFIRM_CANCEL_NO: 'Non, garder',
      CANCELLATION_SUCCESS: 'Retrait annulé. Votre solde a été remboursé.',
      DEPOSIT_CANCELLATION_SUCCESS: 'Dépôt annulé.',
      DEPOSIT_NOW_UNDER_REVIEW: 'Ce dépôt n’a pas pu être annulé : un paiement réel a été trouvé et est en cours de vérification. Il sera crédité automatiquement une fois confirmé.',
      DEPOSIT_STATUS_UPDATED: 'Ce dépôt a été mis à jour — consultez son nouveau statut dans la liste.',
      CANCEL_NOT_POSSIBLE_YET: 'Vos cartes sont en cours de traitement et le dépôt sera finalisé dans quelques secondes — il ne peut plus être annulé.',
      CANCEL_NOT_POSSIBLE_YET_ORANGE: 'Vos cartes attendent leur tour sur une ligne Orange et seront traitées dans les prochaines minutes (jusqu’à une heure en cas d’affluence) — le dépôt ne peut plus être annulé. Suivez-le dans l’onglet Portefeuille.',
      CANCEL_NOT_POSSIBLE_YET_TT: 'Vos cartes attendent leur tour sur une ligne Tunisie Telecom et seront traitées dans les prochaines minutes (jusqu’à une heure en cas d’affluence) — le dépôt ne peut plus être annulé. Suivez-le dans l’onglet Portefeuille.',
      CANCEL_NOT_POSSIBLE_GENERIC: 'Ce dépôt est encore en cours de résolution avec le prestataire de paiement et ne peut pas être annulé pour le moment. Réessayez sous peu.',
      CANCEL_NOT_POSSIBLE_CARD: 'Un paiement par carte est en cours de vérification sur ce dépôt — il ne peut plus être annulé. Il sera crédité ou clôturé dans quelques minutes.',
      DEPOSIT_PROCESSING_HINT: 'Ce dépôt est en cours de traitement avec le prestataire de paiement.',
      DEPOSIT_REVIEW_BODY: 'Ce dépôt est en cours de vérification par le prestataire de paiement. Il sera crédité automatiquement une fois confirmé (cela peut prendre quelques jours).',
      DEPOSIT_REVIEW_AUTO_BODY: 'Vos cartes ont été acceptées et l’opérateur confirme le montant. Cela prend généralement quelques minutes — le dépôt est crédité automatiquement.',
      CLOSE: 'Fermer',

      GENERIC_ERROR: 'Une erreur est survenue. Réessayez.',
      ERR_CARD_ALREADY_USED: 'Cette carte de recharge a déjà été utilisée. Vérifiez le code ou essayez une autre carte.',
      ERR_CARD_INVALID: 'Ce code de carte n\'est pas valide. Vérifiez les chiffres sous la zone à gratter.',
      ERR_CARD_IN_PROGRESS: 'Cette carte est déjà en cours de traitement. Patientez quelques minutes puis réessayez — inutile de changer de carte.',
      ERR_CARD_UNDER_REVIEW: 'Cette carte est en cours de vérification par l\'opérateur. Elle sera traitée automatiquement — ne la soumettez pas à nouveau pour le moment.',
      ERR_CARD_IN_PROGRESS_AT: 'Cette carte est déjà en cours de traitement. Réessayez après {{time}} — inutile de changer de carte.',
      ERR_CARD_UNDER_REVIEW_AT: 'Cette carte est en cours de vérification par l\'opérateur. Réessayez après {{time}} — ne la soumettez pas avant.',
      ERR_OPERATOR_BUSY: 'L\'opérateur ne peut pas traiter cette recharge pour le moment. Réessayez dans quelques minutes.',
      ERR_NO_LINE: 'Aucune ligne n’est libre pour prendre vos cartes pour le moment. Vos cartes n’ont pas été utilisées — réessayez dans quelques minutes. Cela ne compte pas comme une tentative échouée.',
      ERR_NO_LINE_AT: 'Aucune ligne n’est libre pour prendre vos cartes pour le moment. Vos cartes n’ont pas été utilisées — réessayez après {{time}}. Cela ne compte pas comme une tentative échouée.',
      ERR_CARDS_ABOVE_MAX: '{{max}} carte(s) maximum par dépôt sur cette ligne pour le moment — retirez des cartes et réessayez.',
      ERR_CARDS_ABOVE_MAX_PAUSED: 'Les dépôts sur cette ligne sont suspendus pour le moment — réessayez plus tard.',
      ERR_CARD_REFUSED: 'L’opérateur a refusé cette carte. Vérifiez le code ou essayez une autre carte.',
      ERR_DEPOSIT_REJECTED: 'Ce dépôt a été refusé. Aucun montant n\'a été prélevé — vérifiez vos codes et réessayez.',
      PROVIDER_UNAVAILABLE: 'Le service de paiement n\'a pas répondu. Veuillez réessayer dans un instant.',
      ELIGIBILITY_NOT_TND: 'Les méthodes TND ne sont disponibles que pour les utilisateurs tunisiens.',
    },
  },
};
